import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getRouteFields() {
  const response = await defaultFetch('/form/RouteView/Fields');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function useRouteFields() {
  return useQuery({
    queryKey: ['route-fields'],
    queryFn: async () => getRouteFields(),
    refetchOnWindowFocus: false
  });
}
